import { apiFilesBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

const interfacesApiRoutes = {
    list: apiFilesBaseURL + "files/interfaces/",
    listTransportAuthority: apiFilesBaseURL + "files/interfaces/ta/",
    create: apiFilesBaseURL + "files/interfaces/",
    createTransportAuthority: apiFilesBaseURL + "files/interfaces/ta/",
    update: apiFilesBaseURL + "files/interfaces/",
    updateTransportAuthority: apiFilesBaseURL + "files/interfaces/ta/",
    delete: apiFilesBaseURL + "files/interfaces/",
    deleteTransportAuthority: apiFilesBaseURL + "files/interfaces/ta/",
    uploadImage: apiFilesBaseURL + "files/interfaces/upload/",
    uploadImageTransportAuthority: apiFilesBaseURL + "files/interfaces/upload/ta/",
};

export class InterfaceAPI {
    static create(interfaceI) {
        return API.authenticatedRequest({
            url: interfacesApiRoutes.create,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(interfaceI)
        });
    }

    static createTransportAuthority(interfaceI) {
        return API.authenticatedRequest({
            url: interfacesApiRoutes.createTransportAuthority,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(interfaceI)
        });
    }

    static update(interfaceId, interfaceI) {
        const url = new URL(interfaceId, interfacesApiRoutes.update);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.PATCH,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(interfaceI)
        });
    }

    static updateTransportAuthority(interfaceId, interfaceI) {
        const url = new URL(interfaceId, interfacesApiRoutes.updateTransportAuthority);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.PATCH,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(interfaceI)
        });
    }

    static delete(interfaceId) {
        const url = new URL(interfaceId, interfacesApiRoutes.delete);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.DELETE,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static deleteTransportAuthority(interfaceId) {
        const url = new URL(interfaceId, interfacesApiRoutes.deleteTransportAuthority);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.DELETE,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static list(providerId = '') {
        return API.authenticatedRequest({
            url: providerId === '' ? interfacesApiRoutes.list : `${interfacesApiRoutes.list}?provId=${providerId}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static listTransportAuthority() {
        return API.authenticatedRequest({
            url: interfacesApiRoutes.listTransportAuthority,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static uploadImage(image) {
        var formData = new FormData();
        formData.append("file", image);

        var request = {
            url: interfacesApiRoutes.uploadImage,
            method: HTTPMethod.POST,
            contentType: ContentType.MULTIPART,
            token: authenticationCentral.accessToken,
            body: formData
        };
        return API.authenticatedRequest(request);
    }

    static uploadImageTransportAuthority(image) {
        var formData = new FormData();
        formData.append("file", image);

        var request = {
            url: interfacesApiRoutes.uploadImageTransportAuthority,
            method: HTTPMethod.POST,
            contentType: ContentType.MULTIPART,
            token: authenticationCentral.accessToken,
            body: formData
        };
        return API.authenticatedRequest(request);
    }
}



// WEBPACK FOOTER //
// ./src/api/files/InterfaceAPI.js